<template>
	<div>
		<div v-if="!visualizar">
			<div class="no-print">
				<div v-if="!modal && cabecalho" class="fl-cabecalho no-print">
					<div class="row">
						<div class="col-xs-12 col-md-3">
							<i class="icon icon-desapacho_aeronaves"></i>
							<h3>{{ _traducao('global', 'despacho').toUpperCase() }}</h3>
							<h4>{{ _traducao('menuMonitoramento', 'menuMonitoraAeronaves').toUpperCase() }}</h4>
						</div>

						<div class="col-md-5 col-xs-12">
							<span v-if="form.id == 0">
								<i class="icon icon-solicitacao_nova_solicitacao icon-sub"></i>
								<h3>{{ _traducao('global', 'novo') }}</h3>
							</span>

							<span v-if="form.id != 0">
								<i class="icon icon-editar icon-sub"></i>
								<h3>{{ _traducao('global', 'editar').toUpperCase() }}</h3>
							</span>

							<h4>{{ _traducao('global', 'despacho').toUpperCase() }}</h4>
						</div>

						<div class="col-md-4 col-xs-12">
							<button @click="voltaLista()" :title="_traducao('global', 'voltar')" class="btn btn-default pull-right btn-lg">
								<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
							</button>

							<button
								class="btn btn-default pull-right btn-lg"
								:title="_traducao('global', 'imprimir')"
								v-show="form.id != 0"
								style="margin-right: 20px"
								type="button"
								@click="clickPrint(0)"
							>
								<i class="icon-imprimir" style="font-size: 18px"></i>
							</button>
						</div>
					</div>
				</div>

				<div v-if="form.numero != ''">
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'codigoSituacao')" />

					<div class="row">
						<div class="col-xs-12">
							<p style="margin-bottom: 0px; margin-top: 6px">
								{{ form.numero }} -
								<span v-if="form.status == 'A'">{{ _traducao('global', 'aberta').toUpperCase() }}</span>
								<span v-if="form.status == 'E'">{{ _traducao('global', 'encerrada').toUpperCase() }}</span>
							</p>
						</div>
					</div>
				</div>
				<div>
					<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'tipoDespacho')" />
				</div>

				<div class="row">
					<div class="col-md-3 col-xs-12" v-if="_getPrivilegio(106) && _prevencao_qualificada">
						<button
							type="button"
							@click="clickSetaTipo('Q')"
							:disabled="editando"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'Q'}"
						>
							{{ _traducao('global', 'preventiva').toUpperCase() }}
							<i v-show="form.tipo == 'Q'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
					<div class="col-md-3 col-xs-12">
						<button
							type="button"
							@click="clickSetaTipo('E')"
							:disabled="editando"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'E'}"
						>
							{{ _traducao('global', 'emergencial').toUpperCase() }}
							<i v-show="form.tipo == 'E'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
					<!-- <div class="col-md-3 col-xs-12">
					<button type="button" @click="clickSetaTipo('C')" :disabled="editando" class="btn btn-block btn-default"
						:class="{'btn-success' : form.tipo == 'C'}">
						{{_traducao('global', 'critica').toUpperCase()}}
						<i v-show="form.tipo == 'C'" class="fa fa-fw fa-check-circle"></i>
					</button>
				</div> -->
					<div class="col-md-3 col-xs-12">
						<button
							type="button"
							@click="clickSetaTipo('P')"
							:disabled="editando && form.ordem_codigo != null && form.codigo_prevencao == ''"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'P'}"
						>
							{{ _traducao('global', 'planejada').toUpperCase() }}
							<i v-show="form.tipo == 'P'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
					<div class="col-md-3 col-xs-12">
						<button
							type="button"
							@click="clickSetaTipo('M')"
							:disabled="editando && form.ordem_codigo != null && form.codigo_prevencao == ''"
							class="btn btn-block btn-default"
							:class="{'btn-success': form.tipo == 'M'}"
						>
							{{ _traducao('global', 'manutencao').toUpperCase() }}
							<i v-show="form.tipo == 'M'" class="fa fa-fw fa-check-circle"></i>
						</button>
					</div>
				</div>

				<div class="row" v-show="form.tipo == 'P'">
					<div class="col-md-12">
						<flCabecalhoForm cls="print-titulo-form-20" :texto="_traducao('global', 'ordemDeMissao')" />
					</div>

					<div class="col-md-2 col-xs-12">
						<label>{{ _traducao('global', 'ordemDeMissao') }}:</label>
						<br />
						<p>{{ form.ordem_codigo | na }}</p>
					</div>

					<div class="col-md-2 col-xs-12">
						<label>{{ _traducao('global', 'data') }}:</label>
						<br />
						<p>{{ form.ordem_data_inicio | dataTempo | na }}</p>
					</div>

					<div class="col-md-4 col-xs-12">
						<label>{{ _traducao('global', 'descricao') }}:</label>
						<br />
						<p v-html="form.ordem_descricao"></p>
					</div>
				</div>

				<div v-show="form.tipo == 'Q'">
					<flCabecalhoForm cls="print-titulo-form-20" :texto="'Prevenção Qualificada'" />
					<div class="row">
						<div class="col-md-2 col-xs-12">
							<label>Prevenção:</label>
							<br />
							<p>{{ form.prevencao_codigo | na }}</p>
						</div>

						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'inicio') }}:</label>
							<br />
							<p>{{ form.prevencao_inicio | dataTempo | na }}</p>
						</div>
						<div class="col-md-2 col-xs-12">
							<label>{{ _traducao('global', 'fim') }}:</label>
							<br />
							<p>{{ form.prevencao_fim | dataTempo | na }}</p>
						</div>

						<div class="col-md-4 col-xs-12">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<br />
							<p>{{ form.prevencao_descricao | na }}</p>
						</div>
					</div>
				</div>

				<div v-if="this.form.tipo != ''">
					<flCabecalhoForm
						:msg="_traducao('global', 'obrigatorio')"
						cls="print-titulo-form-20"
						:texto="_traducao('global', 'dadosDoDespacho')"
					/>

					<div class="row">
						<div class="col-md-2 col-xs-12 form-group" :class="{'has-error': erro.data_inicio != ''}">
							<label>* {{ _traducao('global', 'dataAbertura') }}:</label>
							<flDateTime
								@v-model="(val) => (form.data_inicio = val)"
								:value="form.data_inicio"
								:lang="_getLangDp"
								:placeholder="_formatDate + ' HH:MM'"
								name="teste"
								:format="_formatDate + ' HH:mm'"
							/>
							<p class="help-block" v-if="erro.data_inicio">{{ erro.data_inicio }}</p>
						</div>

						<div class="col-md-6 col-xs-12">
							<div class="row">
								<div
									class="col-md-4 col-xs-12 form-group"
									v-show="form.tipo != 'Q'"
									:class="{'has-error': erro.numero_chamada != ''}"
								>
									<label>Nº {{ _traducao('global', 'chamada') }}:</label>
									<input
										type="text"
										:disabled="true"
										class="form-control input-sm"
										placeholder="0000-00000000-0"
										v-mask="'0000-00000000-0'"
										v-model="form.numero_chamada"
									/>
									<p class="help-block" v-if="erro.numero_chamada != ''">{{ erro.numero_chamada }}</p>
								</div>

								<div class="col-md-4 col-xs-12 form-group" v-show="form.tipo != 'Q'" :class="{'has-error': erro.numero_bo != ''}">
									<label>Nº CIOPS:</label>
									<input
										type="text"
										class="form-control input-sm"
										placeholder="0000-000000000-000"
										v-mask="'0000-000000000-000'"
										v-model="form.numero_bo"
									/>
								</div>
							</div>
						</div>
					</div>

					<!-- NATUREZA DA MISSAO -->
					<div class="row">
						<div class="col-xs-12 col-md-8 form-group" :class="{'has-error': erro.tipo_missao != ''}">
							<label>* Tipo da Missão:</label>
							<v-select
								v-model="form.tipo_missao"
								class="form-control input-sm"
								label="descricao"
								:options="tiposDeMissoes"
							></v-select>
							<p class="help-block" v-if="erro.tipo_missao != ''">{{ erro.tipo_missao }}</p>
						</div>
						<div
							class="col-xs-12 col-md-4 form-group"
							:class="{'has-error': erro.tipo_classificacao != ''}"
							v-if="form.tipo_missao.id == '4'"
						>
							<label>* Qual o tipo?</label>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									@click="
										form.tipo_classificacao = 'R'
										erro.tipo_classificacao = ''
									"
									:class="{'btn-info': form.tipo_classificacao == 'R'}"
									class="btn btn-default btn-sm"
								>
									Repressão
								</button>
								<button
									type="button"
									@click="
										form.tipo_classificacao = 'P'
										erro.tipo_classificacao = ''
									"
									:class="{'btn-info': form.tipo_classificacao == 'P'}"
									class="btn btn-default btn-sm"
								>
									Prevenção
								</button>
							</div>
							<p class="help-block" v-if="erro.tipo_classificacao">{{ erro.tipo_classificacao }}</p>
						</div>
					</div>
					<!-- CLASSIFICACAO E SUB -->
					<div class="row">
						<div
							class="col-xs-12 col-md-12 form-group"
							:class="{'has-error': erro.classificacao != ''}"
							v-show="this.listaClasFilter != ''"
						>
							<label>* {{ _traducao('global', 'classificacao') }}:</label>
							<v-select
								v-model="form.classificacao"
								class="form-control input-sm"
								:options="listaClasFilter"
								label="descricao"
							></v-select>
							<p class="help-block" v-if="erro.classificacao != ''">{{ erro.classificacao }}</p>
						</div>
						<div
							class="col-xs-12 col-md-12 form-group"
							:class="{'has-error': erro.subclassificacao != ''}"
							v-show="listaSubFilter != ''"
						>
							<label>* {{ _traducao('global', 'subclassificacao') }}:</label>
							<v-select
								v-model="form.subclassificacao"
								class="form-control input-sm"
								:options="listaSubFilter"
								label="descricao"
							></v-select>
							<p class="help-block" v-if="erro.subclassificacao != ''">{{ erro.subclassificacao }}</p>
						</div>
					</div>
					<!-- <div class="row">
					<div class="col-xs-12 col-md-12 form-group" :class="{'has-error' : erro.divisao != ''}" v-show="listaDivFilter != ''">
						<label>Divisão:</label>
						<v-select v-model="form.divisao" class="form-control input-sm" :options="listaDivFilter" label="descricao"></v-select>
						<p class="help-block" v-if="erro.divisao != ''">{{erro.divisao}}</p>
					</div>
				</div> -->

					<!-- CONTEXTO OPERATIVO -->
					<div>
						<div class="row">
							<div class="col-xs-12 form-group" :class="{'has-error': erro.houve_contexto != ''}">
								<label>* {{ _traducao('global', 'haContextoOperativo') }}</label> <br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.houve_contexto = '1'
											erro.houve_contexto = ''
										"
										:class="{'btn-info': form.houve_contexto == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.houve_contexto = '0'
											erro.houve_contexto = ''
										"
										:class="{'btn-info': form.houve_contexto == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.houve_contexto != ''">{{ erro.houve_contexto }}</p>
							</div>
						</div>
						<div class="row" v-if="form.houve_contexto == '1'">
							<div class="col-xs-12 col-md-6 form-group" :class="{'has-error': erro.contexto_operativo != ''}">
								<label>* {{ _traducao('global', 'contextoOperativo') }}</label>
								<v-select
									v-model="form.contexto_operativo"
									class="form-control input-sm"
									:options="contextos"
									label="descricao"
								></v-select>
								<p class="help-block" v-if="erro.contexto_operativo != ''">{{ erro.contexto_operativo }}</p>
							</div>
						</div>
					</div>

					<!-- DEMANDA REPRIMIDA PMSP -->
					<div v-if="_idCliente == 14">
						<div class="row">
							<div class="col-xs-12 form-group" :class="{'has-error': erro.demanda_reprimida != ''}">
								<label>* Demanda Reprimida?</label> <br />
								<div class="btn-group print-button-group" role="group">
									<button
										type="button"
										@click="
											form.demanda_reprimida = '1'
											erro.demanda_reprimida = ''
										"
										:class="{'btn-info': form.demanda_reprimida == '1'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'sim') }}
									</button>
									<button
										type="button"
										@click="
											form.demanda_reprimida = '0'
											erro.demanda_reprimida = ''
										"
										:class="{'btn-info': form.demanda_reprimida == '0'}"
										class="btn btn-default btn-sm"
									>
										{{ _traducao('global', 'nao') }}
									</button>
								</div>
								<p class="help-block" v-if="erro.demanda_reprimida != ''">{{ erro.demanda_reprimida }}</p>
							</div>
						</div>
						<div class="row" v-if="form.demanda_reprimida == '1'">
							<div class="col-xs-12 col-md-12 form-group" :class="{'has-error': erro.descricao_demanda_reprimida != ''}">
								<label>* Descrição</label>
								<textarea rows="4" class="form-control input-sm" v-model="form.descricao_demanda_reprimida"></textarea>
								<p class="help-block" v-if="erro.descricao_demanda_reprimida != ''">{{ erro.descricao_demanda_reprimida }}</p>
							</div>
						</div>

						<hr />
					</div>

					<!-- HISTÓRICO -->
					<div>
						<div class="row">
							<div class="col-xs-12 form-group" :class="{'has-error': erro.historico != ''}">
								<label>* {{ _traducao('global', 'historico') }}:</label>
								<textarea rows="4" class="form-control input-sm" style="resize: none" v-model="form.historico"></textarea>
								<p class="help-block" v-if="erro.historico != ''">{{ erro.historico }}</p>
							</div>
						</div>
					</div>

					<!-- AERONAVES -->
					<div v-if="form.demanda_reprimida == '' || form.demanda_reprimida == '0'">
						<div v-for="(item, index) in form.aeronave" :key="index">
							<div class="row">
								<div :class="{'has-error': item.erro != ''}" class="col-md-4 col-xs-12 form-group" style="margin-bottom: 10px">
									<label>* {{ _traducao('global', 'aeronave') }} {{ index + 1 }}: </label>
									<span class="pull-right" v-show="index > 0">
										<a
											href="#"
											:disabled="id_aeronave == item.id_aeronave"
											style="color: red"
											@click.prevent="form.aeronave.splice(index, 1)"
											type="button"
											><i class="fa fa-fw fa-trash"></i>{{ _traducao('global', 'remover').toUpperCase() }}</a
										>
									</span>
									<select
										class="form-control input-sm"
										@change="addTripulacao(index)"
										:disabled="id_aeronave == item.id_aeronave"
										v-model="item.id_aeronave"
									>
										<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
										<option v-for="item in aeronaves" v-if="_exibeAeroOrgao(item)" :value="item.id" :key="item.id">
											{{ item.codinome }} - {{ item.prefixo }}
										</option>
									</select>
									<p class="help-block" v-if="item.erro != ''">{{ item.erro }}</p>
								</div>

								<!-- BASE -->
								<div class="col-md-2 col-xs-12 form-group" :class="{'has-error': item.erroBase != ''}">
									<label>* {{ _traducao('global', 'base') }}:</label>
									<select v-model="item.base" class="form-control input-sm">
										<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
										<option v-for="item in bases" :key="item.descricao" :value="item.id">{{ item.descricao }}</option>
									</select>
									<p class="help-block" v-if="item.erroBase">{{ item.erroBase }}</p>
								</div>
							</div>

							<div class="row" v-if="item.id_aeronave != ''" v-for="(trip, idxTrip) in item.tripulacao" :key="trip.id">
								<div class="col-md-1 col-xs-1"></div>

								<div class="col-md-4 col-xs-11 form-group" :class="{'has-error': trip.erroFuncao != ''}">
									<label>{{ _traducao('global', 'funcao') }}:</label>
									<select
										:disabled="trip.funcao == 'Piloto em Comando'"
										@change="carregaUsuariosTripulacao(index, idxTrip, trip.funcao, true)"
										class="form-control input-sm"
										v-model="trip.funcao"
									>
										<option value="">{{ _traducao('global', 'escolha').toUpperCase() }}</option>
										<option value="Piloto em Comando">
											<span v-if="form.voo_instrucao == 0">
												{{ _traducao('global', 'primeiroPilotoComando').toUpperCase() }}
											</span>
											<span v-else>
												{{ _traducao('global', 'instrutorVoo').toUpperCase() }}
											</span>
										</option>
										<option value="Piloto em Instrução">{{ _traducao('global', 'pilotoInstrucao').toUpperCase() }}</option>
										<option value="Copiloto">{{ _traducao('global', 'segundoPilotoComando').toUpperCase() }}</option>
										<option value="Mecânico">{{ _traducao('global', 'mecanico').toUpperCase() }}</option>
										<option value="Operador Aerotático">{{ _traducao('global', 'operadorAerotatico').toUpperCase() }}</option>
										<option value="TAS">TAS</option>
										<option value="Estagiário">{{ _traducao('global', 'estagiario').toUpperCase() }}</option>
									</select>
									<p class="help-block" v-if="trip.erroFuncao">{{ trip.erroFuncao }}</p>
								</div>

								<div v-if="_isMobile" class="col-xs-1"></div>

								<div class="col-md-5 col-xs-11 form-group" :class="{'has-error': trip.erroTrigrama != ''}">
									<label>{{ _traducao('global', 'nome') }}:</label>
									<small v-show="idxTrip == 0 && form.voo_instrucao == 0" class="text-info pull-right"
										><i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'obrigPilotoComando') }}</small
									>
									<small v-show="idxTrip == 0 && form.voo_instrucao == 1" class="text-info pull-right"
										><i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'obrigInstrutorVoo') }}</small
									>
									<select
										v-if="_isMobile"
										v-model="trip.trigrama"
										@blur="setaNomeTripulanteTrigrama(index, idxTrip, trip.usuarios, trip.trigrama)"
										class="form-control input-sm"
									>
										<option v-for="(usr, idx) in trip.usuarios" :key="idx" :value="usr.trigrama">
											{{ usr.trigrama }} - {{ usr.nome }}
										</option>
									</select>

									<flSelect
										:list="trip.usuarios"
										:value="trip.trigrama == '' ? '' : trip.trigrama + ' - ' + trip.nome"
										v-show="!trip.load"
										v-if="!_isMobile"
										@v-model="(input) => setaNomeTripulanteTrigrama(index, idxTrip, trip.usuarios, input)"
										:return="'trigrama'"
										:label="'descricao'"
									/>

									<flCarregando v-show="trip.load" />
									<p class="help-block" v-if="trip.erroTrigrama">{{ trip.erroTrigrama }}</p>
								</div>

								<div v-if="_isMobile" class="col-xs-1"></div>

								<div class="col-md-2 col-xs-11 form-group">
									<label v-show="!_isMobile" style="color: #f9f9f9">teste:</label>
									<button
										v-show="idxTrip != 0"
										class="btn btn-sm btn-block btn-danger"
										type="button"
										@click="item.tripulacao.splice(idxTrip, 1)"
									>
										<i class="fa fa-trash fa-fw"></i> {{ _traducao('global', 'remover').toUpperCase() }}
									</button>
								</div>
							</div>

							<div class="row" v-if="item.id_aeronave != ''">
								<div class="col-md-1 col-xs-1"></div>
								<div class="col-md-3 col-xs-11">
									<button class="btn btn-sm btn-block btn-info" @click="clickAddTripulacao(index)" type="button">
										<i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionarTripulacao').toUpperCase() }}
									</button>
								</div>
							</div>

							<hr />
						</div>

						<div class="row">
							<div class="col-xs-12 col-md-3">
								<button class="btn btn-sm btn-block btn-info" title="Adicionar aeronave" @click="clickAddAero()" type="button">
									<i class="fa fa-fw fa-plus"></i>{{ _traducao('global', 'adicionarAeronave').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>

					<!-- BTN SALVAR -->
					<div>
						<div class="row" style="margin-bottom: 20px">
							<hr style="margin-top: 2px; margin-bottom: 20px; margin-top: 20px" />
							<div class="col-lg-10 col-xs-9"></div>
							<div class="col-lg-2 col-xs-12">
								<button type="button" @click="clickSalva" class="btn btn-block btn-success pull-right">
									<i class="fa fa-check" aria-hidden="true"></i> {{ _traducao('global', 'salvar').toUpperCase() }}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- modal com a lista de ordem de missao -->
			<modal ref="modalOrdem">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalOrdem.modalHide()
						exibirEncerradas = false
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaOrdemDeMissao').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'selecioneOrdemMissaoAbaixo') }}.

							<button
								class="btn btn-xs pull-right"
								:class="{'btn-default': !exibirEncerradas, 'btn-success': exibirEncerradas}"
								@click="exibirEncerradas = !exibirEncerradas"
							>
								<i v-if="!exibirEncerradas" class="fa fa-fw fa-circle-o"></i>
								<i v-if="exibirEncerradas" class="fa fa-fw fa-check-circle"></i>
								{{ _traducao('global', 'exibirEncerradas') }}
							</button>
						</p>
					</div>
				</div>

				<div v-show="ordens.length > 0" class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaOrdem"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table class="table table-lista table-striped table-siga table-hover">
									<thead>
										<tr>
											<th style="width: 10%">
												{{ _traducao('global', 'status') }}
											</th>
											<th style="width: 20%">
												{{ _traducao('global', 'ordemDeMissao') }}
											</th>
											<th>{{ _traducao('global', 'solicitacao') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'inicio') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'cadastro') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaOrdem(item)"
											v-if="!exibirEncerradas ? item.status.toUpperCase() == 'EM EXECUÇÃO' : item.status != ''"
											v-for="(item, idxT) in _ordens"
											:key="idxT"
										>
											<td>
												<span v-if="item.status.toUpperCase() == 'ABERTA'">
													<div class="text-info">
														{{ _traducao('global', 'aberta').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'EM EXECUÇÃO'">
													<div class="text-info">
														{{ _traducao('global', 'emExecucao').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'ENCERRADA'">
													<div class="text-success">
														{{ _traducao('global', 'encerrada').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'CANCELADA'">
													<div class="text-danger">
														{{ _traducao('global', 'cancelada').toUpperCase() }}
													</div>
												</span>
											</td>
											<td>
												{{ item.codigo }}
												<br />
												<small v-html="item.descricao_ordem"></small>
											</td>
											<td style="max-width: 400px; white-space: inherit">
												<span v-if="item.descricao_solicitacao == ''">{{
													_traducao('global', 'semSolicitacao').toUpperCase()
												}}</span>
												{{ item.codigo_solicitacao }}
												<br />
												<small>{{ item.descricao_solicitacao }}</small>
											</td>
											<td>
												{{ item.data_cadastro | dataTempo }}
											</td>
											<td>
												{{ item.data_inicio | dataTempo }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- modal com a lista de prevenções -->
			<modal ref="modalPrevencao">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalPrevencao.modalHide()
						exibirEncerradas = false
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">SELECIONE UMA PREVENÇÃO QUALIFICADA</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i>{{ _traducao('global', 'selecioneOrdemMissaoPrevencaoAbaixo') }}
						</p>
					</div>
				</div>

				<div v-show="_prevencao.length > 0" class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaPrevencao"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table class="table table-lista table-striped table-siga table-hover">
									<thead>
										<tr>
											<th style="width: 10%">
												{{ _traducao('global', 'status') }}
											</th>
											<th style="width: 20%">Prevenção Qualificada</th>
											<th style="width: 10%">{{ _traducao('global', 'inicio') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'fim') }}</th>
											<th style="width: 10%">{{ _traducao('global', 'cadastro') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaPrevencao(item)"
											v-for="(item, idxT) in _prevencao"
											:key="idxT"
										>
											<td>
												<span v-if="item.status == 'A'">
													<div class="text-info">
														{{ _traducao('global', 'ativo').toUpperCase() }}
													</div>
												</span>
												<span v-if="item.status == 'C'">
													<div class="text-danger">
														{{ _traducao('global', 'cancelada').toUpperCase() }}
													</div>
												</span>
												<span v-if="item.status == 'F'">
													<div class="text-success">
														{{ _traducao('global', 'fechado').toUpperCase() }}
													</div>
												</span>
											</td>
											<td>
												{{ item.codigo_prevencao }}
												<br />
												<small>{{ item.descricao }}</small>
											</td>
											<td>
												{{ item.inicio_prevencao | dataTempo }}
											</td>
											<td>
												{{ item.fim_prevencao | dataTempo }}
											</td>
											<td>
												{{ item.data_cadastro | dataTempo }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- MODAL SOLICITACAO OK -->
			<modal ref="modalOk">
				<button type="button" class="close" @click="$refs.modalOk.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">DESPACHO</h4>

				<hr />

				<h2 class="text-center text-success"><i class="fa fa-check-circle"></i> DESPACHO SALVO</h2>

				<h2 class="text-center">
					NÚMERO: <br /><strong>{{ form.numero }}</strong>
				</h2>

				<button
					class="btn btn-default"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						voltaLista()
					"
				>
					<i class="icon-left"></i> {{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
				</button>

				<button
					class="btn btn-default pull-right"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						clickPrint(300)
					"
				>
					<i class="icon-imprimir"></i> {{ _traducao('global', 'imprimir') }}
				</button>
			</modal>

			<div class="print">
				<flPrint ref="printCadastro" />
			</div>
		</div>

		<div v-if="visualizar">
			<!-- cabecalho -->
			<div class="fl-cabecalho no-print" v-if="cabecalho">
				<div class="row">
					<div class="col-md-4 col-xs-12">
						<i class="icon icon-desapacho_aeronaves"></i>
						<h3>{{ _traducao('global', 'despacho').toUpperCase() }}</h3>
						<h4>{{ _traducao('menuMonitoramento', 'menuMonitoraAeronaves').toUpperCase() }}</h4>
					</div>

					<div class="col-md-4 col-xs-12">
						<i class="icon icon-vizualizar icon-sub"></i>
						<h3>{{ _traducao('global', 'visualizar').toUpperCase() }}</h3>
						<h4>{{ _traducao('global', 'despacho').toUpperCase() }}</h4>
					</div>

					<div class="col-md-4 col-xs-12">
						<button @click="voltaLista()" class="btn btn-default pull-right btn-lg" :title="_traducao('global', 'voltar')">
							<i class="icon-left" style="font-size: 18px" aria-hidden="true"></i>
						</button>

						<button
							class="btn btn-default pull-right btn-lg"
							:title="_traducao('global', 'imprimir')"
							style="margin-right: 20px"
							@click="_print()"
						>
							<i class="icon-imprimir" style="font-size: 18px"></i>
						</button>
					</div>
				</div>
			</div>

			<flPrint ref="printVisualizar" />
		</div>
	</div>
</template>

<script>
import flPrint from './print.vue'

export default {
	components: {flPrint},

	props: {
		visualizar: {
			required: true,
			type: Boolean
		},

		cabecalho: {
			type: Boolean,
			required: false,
			default: true
		},

		aeronaves: {
			type: Array
		},

		contextos: {
			type: Array
		},

		subclassificacoes: {
			type: Array
		}
	},

	computed: {
		editando() {
			return this.form.id == 0 ? false : true
		},

		_ordens() {
			if (this.buscaOrdem == '') {
				return _.orderBy(this.ordens, ['codigo'], ['desc'])
			}
			var list = this.ordens.filter((cust) => {
				return (
					cust.status.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0 ||
					cust.codigo.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0 ||
					cust.descricao_ordem.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0
				)
				cust.codigo_solicitacao.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0
				cust.descricao_solicitacao.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >= 0
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		},

		_prevencao() {
			let l = _.filter(this.prevencoes, (item) => {
				return item.status != 'C'
			})

			if (this.buscaPrevencao == '') {
				return _.orderBy(l, ['codigo'], ['desc'])
			}

			var self = this
			var list = l.filter(function (cust) {
				return (
					cust.status.toLowerCase().indexOf(self.buscaPrevencao.toLowerCase()) >= 0 ||
					cust.codigo_prevencao.toLowerCase().indexOf(self.buscaPrevencao.toLowerCase()) >= 0 ||
					cust.descricao.toLowerCase().indexOf(self.buscaPrevencao.toLowerCase()) >= 0
				)
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		}
	},

	data() {
		return {
			contLoad: 0,
			tiposDeMissoes: [],
			dados: [],
			classificacoes: [],
			loadAero: true,
			exibirEncerradas: false,
			modal: false,
			ordens: [],
			prevencoes: [],
			buscaOrdem: '',
			buscaPrevencao: '',
			bases: [],

			ver: false,
			fecha: '',
			id_aeronave: null,
			atualiza_ordem: false,
			form: {
				id: 0,

				aeronave: [
					{
						id_aeronave: '',
						erro: '',
						novo: true,
						tripulacao: [],
						base: '',
						erroBase: ''
					}
				],

				nome_usuario_inseriu: '',
				data_cadastro: '',
				ordem_data_inicio: '',
				ordem_codigo: '',
				ordem_descricao: '',

				prevencao_inicio: '',
				prevencao_fim: '',
				prevencao_codigo: '',
				prevencao_descricao: '',

				id_ordem_missao: '',
				id_prevencao_qualificada: '',
				tipo: '',
				_tipo: '',
				id_usuario: '',
				base: '',
				numero: '',
				status: '',
				data_inicio: '',
				numero_bo: '',
				numero_chamada: '',
				numero_atividade: '',
				subclassificacao: '',
				// divisao:'',
				classificacao: '',
				houve_contexto: '',
				contexto_operativo: '',
				historico: '',
				relatorio_voo_trecho: [],
				voo_instrucao: '0',
				demanda_reprimida: '',
				descricao_demanda_reprimida: '',
				tipo_missao: '',
				tipo_classificacao: ''
			},
			erro: {
				id_aeronave: '',
				tipo: '',
				base: '',
				data_inicio: '',
				numero_bo: '',
				numero_chamada: '',
				subclassificacao: '',
				// divisao:'',
				classificacao: '',
				houve_contexto: '',
				contexto_operativo: '',
				historico: '',
				demanda_reprimida: '',
				descricao_demanda_reprimida: '',
				tipo_missao: '',
				tipo_classificacao: ''
			},

			recebendoDados: true,
			listaClasFilter: [],
			listaSubFilter: [],
			// listaDivFilter: [],
			exibir: false,
			controlaFiltro: false
		}
	},

	mounted() {
		this.form.id_usuario = $sessao.getId()
		this._providerBaseOperacional((lista) => (this.bases = lista))
		this._providerClassificacao((lista) => (this.classificacoes = lista))
		this._providerTipoDeMissao((lista) => (this.tiposDeMissoes = lista))
		// this.carregaDivisoes()
	},

	watch: {
		'form.tipo_missao': function (val, oldVal) {
			// if(this.recebendoDados == false){
			if (val != oldVal) {
				if (val != null) {
					this.listaClasFilter = _.filter(this.classificacoes, (o) => {
						return o.id_tipo_missao == val.id
					})
					this.form.tipo_classificacao = ''
					if (this.listaClasFilter == '') {
						this.form.classificacao = ''
						this.form.subclassificacao = ''
						// this.form.divisao = ''
					} else {
						this.recebendoDados == false ? (this.form.classificacao = '') : (this.recebendoDados = false)
					}
				} else {
					this.listaClasFilter = this.classificacoes
				}
			}
			// }
		},

		'form.classificacao': function (val, oldVal) {
			if (val != oldVal) {
				if (val != null) {
					this.listaSubFilter = _.filter(this.subclassificacoes, (o) => {
						return o.id_classificacao == val.id
					})
					// if(this.listaSubFilter == ''){
					this.form.subclassificacao = ''
					// this.form.divisao = ''
					// }
				} else {
					this.form.subclassificacao = ''
					this.listaSubFilter = this.subclassificacoes
				}
			}
		}
		// 'form.subclassificacao': function(val, oldVal){

		// 	if(val != oldVal){
		// 		if(val != null){
		// 			this.listaDivFilter = _.filter(this.divisoes, o => {return o.id_subclassificacao == val.id})
		// 			// if(this.listaDivFilter == ''){
		// 				this.form.divisao = ''
		// 			// }
		// 		}else{
		// 			this.form.divisao = ''
		// 			this.listaDivFilter = this.divisoes
		// 		}
		// 	}
		// },
	},

	methods: {
		novo() {
			console.log(this.form)
		},

		clickAddTripulacao(index) {
			this.form.aeronave[index].tripulacao.push({
				trigrama: '',
				nome: '',
				erroTrigrama: '',
				funcao: '',
				erroFuncao: '',
				usuarios: [],
				load: false
			})
		},

		addTripulacao(index) {
			if (this.form.aeronave[index].novo) {
				this.form.aeronave[index].tripulacao.push({
					nome: '',
					trigrama: '',
					erroTrigrama: '',
					funcao: 'Piloto em Comando',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 0, 'Piloto em Comando', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					nome: '',
					erroTrigrama: '',
					funcao: this.form.voo_instrucao == 1 ? 'Piloto em Instrução' : 'Copiloto',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 1, this.form.voo_instrucao == 1 ? 'Piloto em Instrução' : 'Copiloto', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					erroTrigrama: '',
					funcao: 'Operador Aerotático',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 2, 'Operador Aerotático', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					nome: '',
					erroTrigrama: '',
					funcao: 'Operador Aerotático',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 3, 'Operador Aerotático', true)

				this.form.aeronave[index].novo = false
			}
		},

		carregaUsuariosTripulacao: function (indexAero, indexTrip, funcao, zeraId) {
			var idPerfil = 0
			if (funcao != '') {
				this.form.aeronave[indexAero].tripulacao[indexTrip].load = true

				// piloto
				if (funcao == 'Piloto em Comando' || funcao == 'Piloto em Instrução' || funcao == 'Copiloto') {
					idPerfil = 14
				}
				// trip Op
				if (funcao == 'Operador Aerotático') {
					idPerfil = 15
				}

				// mecanico
				if (funcao == 'Mecânico') {
					idPerfil = 16
				}

				//tasa
				if (funcao == 'TAS') {
					idPerfil = 17
				}

				// estagiario
				if (funcao == 'Estagiário') {
					idPerfil = '14%7C15'
				}

				this._httpGet('Usuario/get_by_perfil/' + idPerfil, (retorno) => {
					if (retorno._request) {
						this.form.aeronave[indexAero].tripulacao[indexTrip].usuarios = retorno.lista.map((item) => {
							item.descricao = item.trigrama + ' - ' + item.nome
							return item
						})
						this.form.aeronave[indexAero].tripulacao[indexTrip].load = false
						if (zeraId) {
							this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
						} else {
							this.setaNomeTripulante(
								indexAero,
								indexTrip,
								retorno.lista,
								this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario
							)
						}

						this.$forceUpdate()
					}
				})
			}
		},

		setaNomeTripulante(indexAero, indexTrip, usuarios, id_usuario) {
			for (var i in usuarios) {
				if (id_usuario == usuarios[i].id_usuario) {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = usuarios[i].nome
					this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = usuarios[i].trigrama
				}
			}
		},

		setaNomeTripulanteTrigrama(indexAero, indexTrip, usuarios, trigrama) {
			if (trigrama != '' && trigrama != null) {
				this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = trigrama.toUpperCase()

				var idx = _.findIndex(usuarios, function (o) {
					return o.trigrama == trigrama.toUpperCase()
				})

				if (idx >= 0) {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = usuarios[idx].nome
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = usuarios[idx].id_usuario
				} else {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = ''
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
					this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = ''
				}
			} else {
				this.form.aeronave[indexAero].tripulacao[indexTrip].nome = ''
				this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
			}
		},

		novoModal(aeronave) {
			this.modal = true
			this.form.aeronave = []
			this.id_aeronave = aeronave.id
			this.form.aeronave.push({
				id_aeronave: aeronave.id,
				erro: '',
				novo: true,
				base: '',
				erroBase: '',
				tripulacao: []
			})

			this.addTripulacao(this.form.aeronave.length - 1)
		},

		editar(item) {
			this.carrega(item)
		},

		clickAddAero() {
			this.form.aeronave.push({id_aeronave: '', erro: '', tripulacao: [], base: '', erroBase: '', novo: true})
		},

		voltaLista() {
			this.$emit('volta-lista')
		},

		clickSalva() {
			if (this.validaForm()) {
				var aeros = Object.assign([], this.form.aeronave)

				var data = {
					id: this.form.id,
					aeronave: aeros.map((item) => {
						var trips = []
						for (var i in item.tripulacao) {
							if (item.tripulacao[i].trigrama != '') {
								item.tripulacao[i].usuarios = []
								trips.push(item.tripulacao[i])
							}
						}
						item.tripulacao = trips
						return item
					}),
					id_usuario: $sessao.getId(),
					base: this.form.base,
					data_inicio: this._dateTimeToDateSQL(this.form.data_inicio, $sessao.getDateFormat() + ' HH:MM'),
					reds: this.form.numero_bo,
					chamada: this.form.numero_chamada,
					atividade: this.form.numero_atividade,
					id_tipo_missao: this.form.tipo_missao.id,
					tipo_classificacao: this.form.tipo_classificacao,
					id_classificacao: this.form.classificacao.id,
					id_subclassificacao:
						this.form.subclassificacao == '' ? (this.form.subclassificacao = null) : this.form.subclassificacao.id,
					// id_subclassificacao_divisao: this.form.divisao == '' ? this.form.divisao = null : this.form.divisao.id,
					houve_contexto: this.form.houve_contexto,
					id_contexto_operativo: this.form.houve_contexto == 1 ? this.form.contexto_operativo.id : '',
					historico: this.form.historico,
					id_ordem_missao: this.form.id_ordem_missao,
					id_prevencao_qualificada: this.form.id_prevencao_qualificada,
					tipo: this.form.tipo,

					ordem_descricao: this.form.ordem_descricao,
					ordem_codigo: this.form.ordem_codigo,
					ordem_data_inicio: this.form.ordem_data_inicio,
					demanda_reprimida: this.form.demanda_reprimida,
					descricao_demanda_reprimida: this.form.descricao_demanda_reprimida,
					atualiza_ordem: this.atualiza_ordem,

					prevencao_inicio: this.form.prevencao_inicio,
					prevencao_fim: this.form.prevencao_fim,
					prevencao_codigo: this.form.prevencao_codigo,
					prevencao_descricao: this.form.prevencao_descricao
				}

				//return false
				console.log('estou enviando => ', data)
				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})
				this._httpPost('cta-maranhao/Despacho_emergencial/salvar', data, (response) => {
					bus.$emit('load-out')
					if (response._request && response._status) {
						this.form.numero = response.lista.numero
						if (!this.modal) {
							this.$refs.modalOk.modalShow(60)
						}

						this.$emit('despacho-add', response.lista)
					}
				})
			} else {
				bus.$emit('exibir-notificacao', {text: this._traducao('menuEscala', 'menuEvermelho'), type: 'danger'})
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			// PMSP
			if (this._idCliente == 14) {
				if (this.form.demanda_reprimida == '') {
					this.erro.demanda_reprimida = obrigatorio
					passou = false
				} else {
					this.erro.demanda_reprimida = ''

					if (this.form.demanda_reprimida == '1') {
						if (this.form.descricao_demanda_reprimida == '') {
							this.erro.descricao_demanda_reprimida = obrigatorio
							passou = false
						} else {
							this.erro.descricao_demanda_reprimida = ''
						}

						this.form.aeronave = []
					} else {
						this.form.aeronave = this.form.aeronave.map((item, index) => {
							if ((item.base = '')) {
								passou = false
								item.erroBase = obrigatorio
							} else {
								item.erroBase = ''
							}

							if (item.id_aeronave == '') {
								passou = false
								item.erro = obrigatorio
							} else {
								item.erro = ''

								for (var i in this.form.aeronave) {
									if (this.form.aeronave[i].id_aeronave == item.id && index != i) {
										item.erro = 'Esssa aeronave está duplicada.'
										passou = false
									}
								}
							}

							if (item.tripulacao[0].trigrama == '') {
								item.tripulacao[0].erroTrigrama = 'Obrigatório.'
								passou = false
							} else {
								item.tripulacao[0].erroTrigrama = ''
							}

							return item
						})
					}
				}
			} else {
				this.form.aeronave = this.form.aeronave.map((item, index) => {
					if (item.id_aeronave == '') {
						passou = false
						item.erro = obrigatorio
					} else {
						item.erro = ''

						for (var i in this.form.aeronave) {
							if (this.form.aeronave[i].id_aeronave == item.id && index != i) {
								item.erro = 'Esssa aeronave está duplicada.'
								passou = false
							}
						}
					}
					if (item.base == '') {
						item.erroBase = obrigatorio
						passou = false
					} else {
						item.erroBase = ''
					}

					if (item.tripulacao != '') {
						if (item.tripulacao[0].trigrama == '') {
							item.tripulacao[0].erroTrigrama = 'Obrigatório.'
							passou = false
						} else {
							item.tripulacao[0].erroTrigrama = ''
						}
					}
					return item
				})
			}

			if (this.form.data_inicio == '') {
				this.erro.data_inicio = obrigatorio
				passou = false
			} else {
				this.erro.data_inicio = ''
			}

			if (this.form.historico == '') {
				this.erro.historico = obrigatorio
				passou = false
			} else {
				this.erro.historico = ''
			}

			// tipo da missao
			if (this.form.tipo_missao == '' || this.form.tipo_missao == null) {
				this.erro.tipo_missao = obrigatorio
				passou = false
			} else {
				this.erro.tipo_missao = ''
			}

			if (this.form.tipo_missao.id == '4') {
				if (this.form.tipo_classificacao == '' || this.form.tipo_classificacao == null) {
					this.erro.tipo_classificacao = 'Obrigatório.'
					passou = false
				} else {
					this.erro.tipo_classificacao = ''
				}
			}

			// classificacao
			if (this.form.classificacao == '') {
				this.erro.classificacao = obrigatorio
				passou = false
			} else {
				this.erro.classificacao = ''
			}

			// subclassificacao
			if (this.exibir == true) {
				if (!this.form.subclassificacao) {
					this.erro.subclassificacao = obrigatorio
					passou = false
				} else {
					this.erro.subclassificacao = ''
				}
			}

			// if(this.form.numero_chamada == "" && this.form.tipo != 'Q'){
			// 	this.erro.numero_chamada = obrigatorio
			// 	passou = false
			// } else {
			// 	this.erro.numero_chamada = ''
			// }

			// houve contexto
			if (this.form.houve_contexto == '') {
				this.erro.houve_contexto = obrigatorio
				passou = false
			} else {
				this.erro.houve_contexto = ''

				if (this.form.houve_contexto == '1') {
					if (this.form.contexto_operativo == '') {
						this.erro.contexto_operativo = obrigatorio
						passou = false
					} else {
						this.erro.contexto_operativo = ''
					}
				}
			}
			return passou
		},

		carrega(item) {
			this.recebeDados = true
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			this._httpGet('cta-maranhao/Despacho_emergencial/get/' + item.id, (retorno) => {
				console.log('despacho', retorno)

				bus.$emit('load-out')
				if (retorno._request && retorno._status) {
					this.form.id = retorno.lista.id
					this.form.aeronave = retorno.lista.aeronave.map((o) => {
						o.erro = ''
						o.erroBase = ''
						o.tripulacao = o.tripulacao.map((trip) => {
							trip.erroTrigrama = ''
							trip.erroFuncao = ''
							trip.load = true
							trip.novo = false
							trip.usuarios = []
							return trip
						})

						return o
					})

					for (var j in this.form.aeronave) {
						for (var i in this.form.aeronave[j].tripulacao) {
							this.carregaUsuariosTripulacao(j, i, this.form.aeronave[j].tripulacao[i].funcao, false)
						}
					}
					this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
						return o.id == retorno.lista.id_tipo_missao
					})
					this.$nextTick(() => {
						this.form.tipo_classificacao = retorno.lista.tipo_classificacao == null ? '' : retorno.lista.tipo_classificacao
					})
					this.form.inicio_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.inicio_prevencao
					this.form.fim_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.fim_prevencao
					this.form.codigo_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.codigo_prevencao
					this.form.descricao_prevencao =
						retorno.lista.prevencao_qualificada == null ? '' : retorno.lista.prevencao_qualificada.descricao
					this.form.base = retorno.lista.base == null ? '' : retorno.lista.base
					this.form.data_inicio = this._SQLDateToDateTime(retorno.lista.data_inicio, $sessao.getDateFormat() + ' HH:MM')
					this.form.numero_bo = retorno.lista.reds
					this.form.numero_chamada = retorno.lista.chamada
					this.form._tipo = retorno.lista._tipo
					this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
					this.form.data_cadastro = retorno.lista.data_cadastro
					this.form.numero_atividade = retorno.lista.atividade
					this.form.houve_contexto = retorno.lista.houve_contexto
					this.form.historico = retorno.lista.historico
					this.form.numero = retorno.lista.numero
					this.form.demanda_reprimida = retorno.lista.demanda_reprimida
					this.form.descricao_demanda_reprimida = retorno.lista.descricao_demanda_reprimida

					if (!_.isNil(retorno.lista.relatorio_voo_trecho)) {
						this.form.relatorio_voo_trecho = retorno.lista.relatorio_voo_trecho
					} else {
						this.form.relatorio_voo_trecho = []
					}

					this.form.status = retorno.lista.status
					this.form.tipo = retorno.lista.tipo

					this.form.id_ordem_missao = retorno.lista.id_ordem_missao
					this.form.ordem_descricao = retorno.lista.ordem_descricao
					this.form.ordem_codigo = retorno.lista.ordem_codigo
					this.form.ordem_data_inicio = retorno.lista.ordem_data_inicio

					this.form.id_prevencao_qualificada = retorno.lista.id_prevencao_qualificada
					this.form.prevencao_inicio = retorno.lista.prevencao_inicio
					this.form.prevencao_fim = retorno.lista.prevencao_fim
					this.form.prevencao_codigo = retorno.lista.prevencao_codigo
					this.form.prevencao_descricao = retorno.lista.prevencao_descricao

					this.form.classificacao = _.find(this.classificacoes, (o) => {
						return o.id == retorno.lista.id_classificacao
					})

					this.$nextTick(() => {
						this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
							return o.id == retorno.lista.id_subclassificacao
						})
						// setTimeout(() => {
						// 	this.form.divisao = _.find(this.divisoes, o => {return o.id == retorno.lista.id_subclassificacao_divisao})
						// 	if(_.isNil(this.form.divisao)){
						// 		this.form.divisao = ''
						// 	}
						// }, 400)
					})

					if (this.form.houve_contexto == 1) {
						this.form.contexto_operativo = _.find(this.contextos, (o) => {
							return o.id == retorno.lista.id_contexto_operativo
						})
					}

					if (this.visualizar) {
						this.$refs.printVisualizar.carregaDados(this.form)
					}
				}
			})
		},

		clickSetaTipo(tipo) {
			this.form.tipo = tipo

			if (tipo == 'E' || tipo == 'C' || tipo == 'M') {
				this.form.id_ordem_missao = ''
			} else if (tipo == 'P') {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._httpGet('cta-maranhao/Ordem_missao/get_execucao/' + $sessao.getId(), (retorno) => {
					bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						this.ordens = retorno.lista.map((item) => {
							item.status = item.status == null ? '' : item.status
							item.codigo = item.codigo == null ? '' : item.codigo
							item.descricao_ordem = item.descricao_ordem == null ? '' : item.descricao_ordem
							item.codigo_solicitacao = item.codigo_solicitacao == null ? '' : item.codigo_solicitacao
							item.descricao_solicitacao = item.descricao_solicitacao == null ? '' : item.descricao_solicitacao

							return item
						})
						this.$refs.modalOrdem.modalShow()
					}
				})
			} else if (tipo == 'Q') {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._httpGet('Prevencao_qualificada/get', (retorno) => {
					bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						this.prevencoes = retorno.lista
						this.$refs.modalPrevencao.modalShow()
					}
				})
			}
		},

		clickSetaOrdem(ordem) {
			if (this.form.id != 0 && this.form.ordem_codigo == null) {
				this.atualiza_ordem = true
			}

			this.form.tipo = 'P'
			this.form.id_ordem_missao = ordem.id
			this.form.ordem_codigo = ordem.codigo
			this.form.ordem_descricao = ordem.descricao_ordem
			this.form.ordem_data_inicio = ordem.data_inicio

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			// CARREGA O DESPACHO PARA A EDICAO
			this._httpGet('cta-maranhao/Ordem_missao/editar/' + ordem.id, (retorno) => {
				if (retorno._request) {
					bus.$emit('load-out')

					this.$refs.modalOrdem.modalHide()

					this.form.classificacao = _.find(this.classificacoes, (o) => {
						return o.id == retorno.id_classificacao
					})
					this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
						return o.id == retorno.id_subclassificacao
					})
					// this.form.divisao = _.find(this.subclassificacoes, o =>{return o.id == retorno.id_subclassificacao_divisao})

					for (var i in retorno.aeronave) {
						this.form.aeronave = []
						this.form.aeronave.push({
							id_aeronave: retorno.aeronave[i].id_aeronave,
							base: retorno.aeronave[i].base,
							erroBase: '',
							erro: '',
							tripulacao: retorno.aeronave[i].tripulacao.map((item) => {
								item.erroTrigrama = ''
								item.erroFuncao = ''
								item.usuarios = []
								item.load = true
								item.novo = false
								return item
							})
						})
					}

					for (var j in this.form.aeronave) {
						for (var i in this.form.aeronave[j].tripulacao) {
							this.carregaUsuariosTripulacao(j, i, this.form.aeronave[j].tripulacao[i].funcao, false)
						}
					}

					this.form.houve_contexto = retorno.houve_contexto
					this.form.base = retorno.base

					if (ordem.descricao_solicitacao != '') {
						this.form.historico = ordem.descricao_solicitacao
					} else {
						this.form.historico = retorno.descricao_situacao
					}

					// se tiver adendo
					if (retorno.descricao_solicitacao != '') {
						this.form.historico += ' ADENDO: ' + retorno.descricao_solicitacao
					}

					if (this.form.houve_contexto == '1') {
						for (var i in this.contextos) {
							if (this.contextos[i].id == ordem.id_contexto_operativo) {
								this.form.contexto_operativo = this.contextos[i]
							}
						}
					}
				}
			})
		},

		clickSetaPrevencao(prevencao) {
			this.form.prevencao_inicio = prevencao.inicio_prevencao
			this.form.prevencao_fim = prevencao.fim_prevencao
			this.form.prevencao_codigo = prevencao.codigo_prevencao
			this.form.prevencao_descricao = prevencao.descricao
			this.form.id_prevencao_qualificada = prevencao.id
			this.form.historico = prevencao.descricao

			this.$refs.modalPrevencao.modalHide()
		},

		getSubclassificacaoById(id) {
			for (var i in this.subclassificacoes) {
				if (this.subclassificacoes[i].id == id) {
					return this.subclassificacoes[i]
				}
			}
		},

		carregaBase(descricao) {
			for (var i = 0; i < this.bases.length; i++) {
				if (descricao == this.bases[i].descricao) {
					this.form.aeronave[0].base = this.bases[i].id
				}
			}
		},

		// carregaDivisoes(){
		// 	this._httpGet('Subclassificacao_divisao/get/', request => {
		// 		bus.$emit('load-out')
		// 		if(request._request){
		// 			if(request._status){
		// 				this.divisoes = request.lista
		// 			}
		// 		}
		// 	})
		// },

		clickPrint(tempo) {
			setTimeout(() => {
				this.$refs.printCadastro.carregaDados(this.form)
				this.$nextTick(() => {
					this._print()
				})
			}, tempo)
		}
	}
}
</script>

<style>
.table-hover-tr:hover td {
	background: #f0f0f0;
	cursor: pointer;
}

.bk-success {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
</style>